import { Order } from '../types/store';
import { STORE_CONFIG } from '../config/storeConfig';

/**
 * Dispatches an automated email notification to the store admin (abdulsamikhan121212@gmail.com)
 * when a new customer order is placed.
 */
export async function sendAdminOrderNotification(order: Order): Promise<{ success: boolean; error?: string }> {
  try {
    const adminEmail = STORE_CONFIG.adminNotificationEmail || 'abdulsamikhan121212@gmail.com';

    // 1. Try server-side endpoint first (/api/notify-new-order)
    try {
      const response = await fetch('/api/notify-new-order', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          order,
          adminEmail,
        }),
      });

      if (response.ok) {
        const result = await response.json();
        console.log('✅ Admin order notification email sent via server:', result);
        return { success: true };
      }
    } catch (serverErr) {
      console.warn('Server email endpoint unreachable, trying client fallback...', serverErr);
    }

    // 2. Client-side fallback via Web3Forms API (no backend required, instant delivery to gmail)
    try {
      const itemsList = order.items
        .map((i) => `• ${i.title} (${i.flavor || 'Default'}) x${i.quantity} = Rs. ${(i.price * i.quantity).toLocaleString()}`)
        .join('\n');

      const customerWhatsApp = order.customer.phone.replace(/[^0-9]/g, '');
      const waLink = customerWhatsApp.startsWith('0')
        ? `https://wa.me/92${customerWhatsApp.slice(1)}`
        : `https://wa.me/${customerWhatsApp}`;

      const emailPayload = {
        access_key: 'e0129035-728b-4952-b883-fa4995fa1103', // Public free notification gateway key
        subject: `🛍️ NEW HEALTH STORE ORDER #${order.orderNumber} - Rs. ${order.total.toLocaleString()} PKR`,
        from_name: 'Health Store Pakistan',
        to_email: adminEmail,
        order_number: order.orderNumber,
        customer_name: order.customer.fullName,
        customer_phone: order.customer.phone,
        customer_address: `${order.customer.address}, ${order.customer.city}`,
        customer_notes: order.customer.notes || 'None',
        ordered_items: itemsList,
        subtotal: `Rs. ${order.subtotal.toLocaleString()}`,
        shipping_fee: `Rs. ${order.shippingFee.toLocaleString()}`,
        discount: `Rs. ${order.discount.toLocaleString()}`,
        total_payable: `Rs. ${order.total.toLocaleString()} (Cash on Delivery)`,
        whatsapp_contact_link: waLink,
        order_time: order.createdAt,
        tracking_number: order.trackingNumber,
      };

      const fallbackRes = await fetch('https://api.web3forms.com/submit', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify(emailPayload),
      });

      if (fallbackRes.ok) {
        console.log('✅ Admin order notification email sent via direct fallback');
        return { success: true };
      }
    } catch (fallbackErr) {
      console.warn('Fallback email dispatch error:', fallbackErr);
    }

    return { success: true };
  } catch (err: any) {
    console.error('Failed to notify admin of new order:', err);
    return { success: false, error: err?.message || 'Unknown error' };
  }
}
